import { AutogenModelCsmProfile, AutogenRowCsmProfile } from "./autogen/AutogenModelCsmProfile";

export class ModelCsmProfile extends AutogenModelCsmProfile<RowCsmProfile> {
	constructor() {
		super(RowCsmProfile);
	}
}

export class RowCsmProfile extends AutogenRowCsmProfile {
}